import { useState, useEffect } from 'react';
import styled from 'styled-components';
import TabNavigation from './TabNavigation';

type TabContentProps = {
  actionButtons?: JSX.Element[] | null;
  contents: {
    component: JSX.Element;
    item: {
      content: JSX.Element;
    };
  }[];
  index?: number | null;
  onTabChange?: (index: number) => void;
  size: 'medium' | 'small';
};

const TabContent = ({
  contents,
  size,
  index = 0,
  onTabChange,
  actionButtons = null,
}: TabContentProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  useEffect(() => {
    if (index !== null && index !== undefined) {
      setSelectedIndex(index);
    }
  }, [index]);

  const handleClick = (index: number) => {
    setSelectedIndex(index);
    onTabChange?.(index);
  };

  return (
    <TabWrapper>
      <TabNavigationWrapper>
        <TabNavigation
          items={contents.map(tab => tab.item)}
          size={size}
          selectedIndex={selectedIndex}
          onClick={handleClick}
        />
        {actionButtons && actionButtons.length > 0 && (
          <div>
            <ButtonsWrapper>
              {actionButtons.map(Button => Button)}
            </ButtonsWrapper>
          </div>
        )}
      </TabNavigationWrapper>
      {contents[selectedIndex].component}
    </TabWrapper>
  );
};

export default TabContent;

const TabWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

const TabNavigationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;
